module.exports = __webpack_public_path__ + "img/hnllogo.4775ee41.png";